import { render } from "./ModalComponent.vue?vue&type=template&id=17428bc9&ts=true"
import script from "./ModalComponent.ts?vue&type=script&lang=ts"
export * from "./ModalComponent.ts?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__